import React from 'react';
import {Col, Row} from 'antd';
import InputFormField from '../../components/data_entry/form/InputFormField';
import PasswordFormField from '../../components/data_entry/form/PasswordFormField';
import {FIELD_NAMES} from './constants';

export default function AccessSection() {
    return (
        <Row gutter={16}>
            <Col xs={24} sm={12} lg={8}>
                <InputFormField
                    form={{
                        label: 'E-mail',
                        name: FIELD_NAMES.EMAIL,
                        rules: [
                            {required: true, message: 'Campo obrigatório'},
                            {type: 'email', message: 'E-mail inválido'},
                        ],
                    }}
                    placeholder="seu@email.com"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <PasswordFormField
                    form={{
                        label: 'Senha',
                        name: FIELD_NAMES.PASSWORD,
                        rules: [
                            {required: true, message: 'Campo obrigatório'},
                            {min: 8, message: 'A senha deve ter no mínimo 8 caracteres'},
                            {
                                pattern: /(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])/,
                                message: 'A senha deve conter letras, números e caractere especial',
                            },
                        ],
                    }}
                    placeholder="Sua senha"
                />
            </Col>
            <Col xs={24} sm={12} lg={8}>
                <PasswordFormField
                    form={{
                        label: 'Confirmar Senha',
                        name: FIELD_NAMES.CONFIRM_PASSWORD,
                        dependencies: [FIELD_NAMES.PASSWORD],
                        rules: [
                            {required: true, message: 'Campo obrigatório'},
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue(FIELD_NAMES.PASSWORD) === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('As senhas não coincidem'));
                                },
                            }),
                        ],
                    }}
                    placeholder="Confirme sua senha"
                />
            </Col>
        </Row>
    );
}
